import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import VueMatchMedia from '@webqam/vue-match-media';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {
  LControlZoom,
  LIcon,
  LMap,
  LMarker,
  LPopup,
  LTileLayer,
} from 'vue2-leaflet';
import Breakpoints from '../utils/Breakpoints';
import { pascalToKebab } from '../utils/String';

delete Icon.Default.prototype._getIconUrl;

const image =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

Icon.Default.mergeOptions({
  iconRetinaUrl: image,
  iconUrl: image,
  shadowUrl: image,
});

Vue.use(VueMatchMedia, { breakpoints: Breakpoints });

Vue.use(VueI18n);

[LControlZoom, LIcon, LMap, LMarker, LPopup, LTileLayer].forEach((component) =>
  Vue.component(pascalToKebab(component.name), component)
);
